import { ICouponsConfig } from '../couponsListSportTab/coupons.model';

export const DAYS: string[] = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

export const TODAY: string = 'Today';

export const MATCHES = {
    TOMORROW: "Tomorrow's Matches",
    MIDWEEK: 'Midweek Matches',
    WEEKEND: 'Weekend Matches',
    TODAY: "Today's Matches",
};

export const COUPONS: Record<string, keyof ICouponsConfig> = {
    CORRECT_SCORE: 'CorrectScore',
    BBTS: 'BTTSInBothHalves',
    DOUBLE_CHANCE: 'DoubleChance',
    DATE_COUPONS: 'DateCoupons',
    MARKET_INCLUSION: 'marketSpecificInclusion',
    MARKET_UNIQUE_IDS: 'marketSpecificForUniqueIDs',
    LEAGUE_COUPONS: 'leagueCoupons',
    MARKET_DATE_EXCLUSION: 'marketSpecificDateExclusion',
};
export const DATED_COUPONS: Record<string, string> = {
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
    MIDWEEK: 'Midweek',
    WEEKEND: 'Weekend',
};
export const UNIQUE_COUPONS: Record<string, string> = {
    BTTSInBothHalves: 'both teams to score in both halves',
    DoubleChance: 'double chance',
    CorrectScore: 'correct score',
};
